import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';
import { nswRevenueUrl } from 'scenes/common/helpers/contacts';

const ExemptionModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal
    header="Important information about exemption"
    isOpen={isOpen}
    onClose={onClose}
  >
    <Text>
      Under the Duties Act 1997 (NSW), small businesses with an aggregate
      turnover of $2 million or less at the time that the policy commences may
      be entitled to an exemption from stamp duty. For more information
      regarding the exemption and whether you qualify, visit the{' '}
      <a href={nswRevenueUrl()} target="_blank" rel="noopener noreferrer">
        NSW government website
      </a>
      .
    </Text>
  </Modal>
);

export default ExemptionModal;
